import { Components } from '@mui/material';
import { listItemButtonClasses } from '@mui/material/ListItemButton';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { alpha } from '@mui/system/colorManipulator';

import tokens from '../tokens';

const MuiListItemButton: NonNullable<Components['MuiListItemButton']> = {
  styleOverrides: {
    root: {
      [`&.${listItemButtonClasses.selected}`]: {
        background: alpha(tokens.palette.secondary.main, tokens.palette.action.selectedOpacity),

        position: 'relative',
        ':after': {
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          width: 5,
          borderRadius: `4px 0 0 4px`,
          background: tokens.palette.secondary.main,
          content: '""',
        },

        '&:hover': {
          background: alpha(tokens.palette.secondary.main, tokens.palette.action.selectedOpacity + tokens.palette.action.hoverOpacity),

          '@media (hover: none)': {
            background: alpha(tokens.palette.secondary.main, tokens.palette.action.selectedOpacity),
          },
        },

        [`&.${listItemButtonClasses.focusVisible}`]: {
          background: alpha(tokens.palette.secondary.main, tokens.palette.action.selectedOpacity + tokens.palette.action.focusOpacity),
        },

        [`& .${listItemIconClasses.root}`]: {
          color: tokens.palette.secondary.main,
        },
      },
    },
  },
};

export default MuiListItemButton;
